var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"l-back-top bg-white txt-c",on:{"click":_vm.goTop}},[_c('span',{staticClass:"icon icon-top f20 c-333"})])
}
var staticRenderFns = []

export { render, staticRenderFns }